export enum HeaderType {
    Light = "light",
    Dark = "dark"
}